import { render, staticRenderFns } from "./OtrosPermisoView.vue?vue&type=template&id=e7af1c5c&scoped=true"
import script from "./OtrosPermisoView.vue?vue&type=script&lang=js"
export * from "./OtrosPermisoView.vue?vue&type=script&lang=js"
import style1 from "./OtrosPermisoView.vue?vue&type=style&index=1&id=e7af1c5c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7af1c5c",
  null
  
)

export default component.exports